

























import Vue from 'vue';
import { RatePlan } from '@/types/roomInterface';
import HotelImageCarousel from '@/components/landing/HotelImageCarousel.vue';
import RoomDetailsModal from '@/modals/landing/RoomDetailsModal.vue';
import TermsOfPromotionsPopup from '@/components/common/public/TermsOfPromotionsPopup.vue';
import { mapState } from 'vuex';
import { HotelInterface } from '@/types/hotelInterface';
import { MealOptions } from '@/constants/mealOption';

export default Vue.extend({
  name: 'RoomTypeCard',
  components: {
    HotelImageCarousel,
    RoomDetailsModal,
    TermsOfPromotionsPopup,
  },
  props: {
    room: {
      type: Object,
      default: null,
    },
  },
  computed: {
    ...mapState({
      hotel: (state: any): HotelInterface => state.landing.hotel.item,
    }),
    roomName(): string {
      if (!this.room || !this.room.name) {
        return '';
      }
      return this.room.name[this.i18nTag()] ? this.room.name[this.i18nTag()] : this.room.name.en;
    },
    ratePlans(): Array<RatePlan> {
      const plans = this.room.rate_plans.filter((x: RatePlan) => !x.united_plan);
      const noMealPlan: RatePlan[] = this.room.rate_plans.filter(
        (x: RatePlan) => x.united_plan && this.getMealOptionScope(x.meal_options!) === MealOptions.no_meals,
      );
      const breakfastPlan: RatePlan[] = this.room.rate_plans.filter(
        (x: RatePlan) => x.united_plan && this.getMealOptionScope(x.meal_options!) === MealOptions.with_breakfast,
      );
      const dinnerPlan: RatePlan[] = this.room.rate_plans.filter(
        (x: RatePlan) =>
          x.united_plan && this.getMealOptionScope(x.meal_options!) === MealOptions.breakfast_with_dinner,
      );
      if (noMealPlan.length === 1) {
        noMealPlan[0].united_plan = false;
      }
      if (breakfastPlan.length === 1) {
        breakfastPlan[0].united_plan = false;
      }
      if (dinnerPlan.length === 1) {
        dinnerPlan[0].united_plan = false;
      }
      plans.push(noMealPlan[0]);
      plans.push(breakfastPlan[0]);
      plans.push(dinnerPlan[0]);
      return plans
        .filter(Boolean)
        .sort((a: RatePlan, b: RatePlan) => (a.amount && b.amount && a.amount > b.amount ? 1 : -1));
    },
    isCampaignHotel(): boolean {
      if (this.hotel && this.hotel.in_campaign) {
        return this.hotel.in_campaign;
      }
      return false;
    },
  },
  methods: {
    hasDiscount(plan: RatePlan): boolean {
      if (plan && plan.discount_amount) {
        return Math.abs(plan.discount_amount) > 0;
      }
      return false;
    },
    selectPlan(rate: RatePlan): void {
      const room = this.room;
      this.$emit('selected', { room, rate });
    },
    openModal(): void {
      const modal: any = this.$refs.roomDetailsModal;
      modal.isOpen = true;
    },
  },
});
